import React from 'react';
import styles from './CameraView.module.css';

export function CameraView({ videoRef, canvasRef, overlayRef }) {
  return (
    <div className={styles.container}>
      <video
        ref={videoRef}
        className={styles.video}
        autoPlay
        playsInline
        muted
      />
      <canvas ref={canvasRef} className={styles.hiddenCanvas} />
      <canvas ref={overlayRef} className={styles.overlay} />
    </div>
  );
}
